<template>

  <div class="music-page">



    <p>
      <iframe src="https://www.youtube.com/embed/ExgpKGmcjDo?rel=0&amp;showinfo=0;start=2" allowfullscreen></iframe>
    </p>



    <p>
      <iframe id="spotify-frame" height="306" src="https://open.spotify.com/embed/album/7nDzwHdSE9tmlPOsIHJWg7" frameborder="0" allowtransparency="true"></iframe>
    </p>
<!-- <iframe src="https://open.spotify.com/embed/album/7nDzwHdSE9tmlPOsIHJWg7" width="300" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe> -->
    <!-- <p>
      <iframe src="https://bandcamp.com/EmbeddedPlayer/album=3760834578/size=large/bgcol=ffffff/linkcol=333333/artwork=none/transparent=true/" seamless><a href="http://johannmiller.bandcamp.com/album/the-ep">The EP by Johann Miller</a></iframe>
    </p> -->

    <ul>
      <li><a href="//johannmiller.bandcamp.com">bandcamp</a></li>
      <li><a href="//soundcloud.com/johannmiller">soundcloud</a></li>
    </ul>

  </div>

</template>

<script>

export default{
  name: 'music-page'
}

</script>

<style scoped>

iframe {
  width: 600px;
  max-width: 100%;
  height: 20rem;
  border: none;
  padding-top: 10px;
  padding-bottom: 15px;
}

ul {
  list-style: none;
  padding: 0;
}

</style>



// WEBPACK FOOTER //
// MusicPage.vue?60fcdc92